import React, { useState } from "react";
import t from "../../../helpers/t";
import SortNav from "../../../components/SortNav";
import { currencyFormat } from "../../../../utils/FormatHelper";

const InvoiceItem = (props) => {
  const { positions, invoice, dispatch } = props;

  let tabs = [
    {
      name: t("position", null, "capital"),
      smallWidth: 2,
      mediumWidth: 1,
      xlargeWidth: 1,
      title: t("position", null, "capital"),
      canSort: false,
    },
    {
      name: t("description", null, "capital"),
      smallWidth: 4,
      mediumWidth: 4,
      xlargeWidth: 4,
      title: t("description", null, "capital"),
      canSort: false,
    },
    {
      name: t("mwst", null, "capital"),
      mediumWidth: 1,
      smallWidth: 1,
      xlargeWidth: 1,
      title: t("mwst", null, "capital"),
      canSort: false,
    },
    {
      name: t("netto", null, "capital"),
      smallWidth: 2,
      mediumWidth: 1,
      xlargeWidth: 1,
      title: t("netto", null, "capital"),
      canSort: false,
    },
    {
      name: t("brutto", null, "capital"),
      smallWidth: 2,
      mediumWidth: 1,
      xlargeWidth: 1,
      title: t("brutto", null, "capital"),
      canSort: false,
    },
  ];

  return (
    <>
      <header className="inb-c-item-details__header small-12 column">
        <SortNav tabs={tabs} listStyle="tight" autoHeight={true} />
      </header>

      {positions.map((position, index) => {
        return (
          <>
            <div
              className="inb-position inb-c-item-details-row row padding-left-35"
              data-inb-position-id={position.id}
              data-inb-context="invoice-positions"
              style={{ paddingLeft: "35px" }}
            >
              <div
                className="large-1 medium-12 small-12 column inb-position__nbr show-label"
                title={t("position", null, "capital")}
              >
                #{position.invoicePos}
              </div>

              <div
                className="large-4 medium-12 small-12 column inb-position__description show-label"
                title={t("description", null, "capital")}
              >
                {position.description}
              </div>
              <div
                className="large-1 medium-12 small-12 column inb-position__mwst show-label"
                title={t("mwst", null, "capital")}
              >
                {position.mwst}%
              </div>
              <div
                className="large-1 medium-12 small-12 column inb-position__netto show-label"
                title={t("netto", null, "capital")}
              >
                {currencyFormat(position.amountNetto)}€
              </div>
              <div
                className="large-1 medium-12 small-12 column inb-position__brutto show-label"
                title={t("brutto", null, "capital")}
              >
                {currencyFormat(position.amountBrutto)}€
              </div>
            </div>
          </>
        );
      })}
    </>
  );
};
export default InvoiceItem;
